'use strict';

var _regeneratorRuntime = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _assertThisInitialized = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var _require = require('events');

var EventEmitter = _require.EventEmitter;

var secp256k1 = require('secp256k1');

var Buffer = require('safe-buffer').Buffer;

var _require2 = require('crypto');

var randomBytes = _require2.randomBytes;

var createDebugLogger = require('debug');

var ms = require('ms');

var _require3 = require('../util');

var pk2id = _require3.pk2id;

var KBucket = require('./kbucket');

var BanList = require('./ban-list');

var DPTServer = require('./server');

var debug = createDebugLogger('devp2p:dpt');

var DPT =
/*#__PURE__*/
function (_EventEmitter) {
  _inherits(DPT, _EventEmitter);

  function DPT(privateKey, options) {
    var _this3;

    _classCallCheck(this, DPT);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(DPT).call(this));
    _this3._privateKey = Buffer.from(privateKey);
    _this3._id = pk2id(secp256k1.publicKeyCreate(_this3._privateKey, false));
    _this3._banlist = new BanList();
    _this3._kbucket = new KBucket(_this3._id);

    _this3._kbucket.on('added', function (peer) {
      return _this3.emit('peer:added', peer);
    });

    _this3._kbucket.on('removed', function (peer) {
      return _this3.emit('peer:removed', peer);
    });

    _this3._kbucket.on('ping', function () {
      var _this4;

      return (_this4 = _this3)._onKBucketPing.apply(_this4, arguments);
    });

    _this3._server = new DPTServer(_assertThisInitialized(_assertThisInitialized(_this3)), _this3._privateKey, {
      createSocket: options.createSocket,
      timeout: options.timeout,
      endpoint: options.endpoint
    });

    _this3._server.once('listening', function () {
      return _this3.emit('listening');
    });

    _this3._server.once('close', function () {
      return _this3.emit('close');
    });

    _this3._server.on('peers', function (peers) {
      return _this3._onServerPeers(peers);
    });

    _this3._server.on('error', function (err) {
      return _this3.emit('error', err);
    });

    var refreshInterval = options.refreshInterval || ms('60s');
    _this3._refreshIntervalId = setInterval(function () {
      return _this3.refresh();
    }, refreshInterval);
    return _this3;
  }

  _createClass(DPT, [{
    key: "bind",
    value: function bind() {
      var _this$_server;

      (_this$_server = this._server).bind.apply(_this$_server, arguments);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _this$_server2;

      clearInterval(this._refreshIntervalId);

      (_this$_server2 = this._server).destroy.apply(_this$_server2, arguments);
    }
  }, {
    key: "_onKBucketPing",
    value: function _onKBucketPing(oldPeers, newPeer) {
      var _this5 = this;

      if (this._banlist.has(newPeer)) return;
      var count = 0;
      var err = null;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        var _loop = function _loop() {
          var peer = _step.value;

          _this5._server.ping(peer).catch(function (_err) {
            _this5._banlist.add(peer, ms('5m'));

            _this5._kbucket.remove(peer);

            err = err || _err;
          }).then(function () {
            if (++count < oldPeers.length) return;
            if (err === null) _this5._banlist.add(newPeer, ms('5m'));else _this5._kbucket.add(newPeer);
          });
        };

        for (var _iterator = oldPeers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          _loop();
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }, {
    key: "_onServerPeers",
    value: function _onServerPeers(peers) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = peers[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var peer = _step2.value;
          this.addPeer(peer).catch(function () {});
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
  }, {
    key: "bootstrap",
    value: function bootstrap(peer) {
      var _this = this;

      return (0, _asyncToGenerator3.default)(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                debug("bootstrap with peer ".concat(peer.address, ":").concat(peer.udpPort));
                _context.next = 3;
                return _this.addPeer(peer);

              case 3:
                peer = _context.sent;

                _this._server.findneighbours(peer, _this._id);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }))();
    }
  }, {
    key: "addPeer",
    value: function addPeer(obj) {
      var _this2 = this;

      return (0, _asyncToGenerator3.default)(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var peer, _peer;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!_this2._banlist.has(obj)) {
                  _context2.next = 2;
                  break;
                }

                throw new Error('Peer is banned');

              case 2:
                debug("attempt adding peer ".concat(obj.address, ":").concat(obj.udpPort)); // check k-bucket first

                peer = _this2._kbucket.get(obj);

                if (!(peer !== null)) {
                  _context2.next = 6;
                  break;
                }

                return _context2.abrupt("return", peer);

              case 6:
                _context2.prev = 6;
                _context2.next = 9;
                return _this2._server.ping(obj);

              case 9:
                _peer = _context2.sent;

                _this2.emit('peer:new', _peer);

                _this2._kbucket.add(_peer);

                return _context2.abrupt("return", _peer);

              case 15:
                _context2.prev = 15;
                _context2.t0 = _context2["catch"](6);

                _this2._banlist.add(obj, ms('5m'));

                throw _context2.t0;

              case 19:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[6, 15]]);
      }))();
    }
  }, {
    key: "getPeer",
    value: function getPeer(obj) {
      return this._kbucket.get(obj);
    }
  }, {
    key: "getPeers",
    value: function getPeers() {
      return this._kbucket.getAll();
    }
  }, {
    key: "getClosestPeers",
    value: function getClosestPeers(id) {
      return this._kbucket.closest(id);
    }
  }, {
    key: "removePeer",
    value: function removePeer(obj) {
      this._kbucket.remove(obj);
    }
  }, {
    key: "banPeer",
    value: function banPeer(obj, maxAge) {
      this._banlist.add(obj, maxAge);

      this._kbucket.remove(obj);
    }
  }, {
    key: "refresh",
    value: function refresh() {
      var peers = this.getPeers();
      debug("call .refresh (".concat(peers.length, " peers in table)"));
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = peers[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var peer = _step3.value;

          this._server.findneighbours(peer, randomBytes(64));
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    }
  }]);

  return DPT;
}(EventEmitter);

module.exports = DPT;